"use client";

import { resetConsent } from "@/lib/useConsent";

/**
 * Footer entry point back to the choice. Consent is only real if it can be withdrawn,
 * so this clears the stored answer and the banner asks again.
 */
export const CookiePreferences = () => (
  <button
    type="button"
    onClick={resetConsent}
    className="text-left uppercase tracking-widest transition-colors duration-300 hover:text-brand-ink"
  >
    Cookies
  </button>
);
